import { currentTutorialAtom, currentTutorialStepAtom, presentTutorialOverlayAtom } from 'app/atoms/tutorials';
import { Tutorial, TutorialRef } from 'app/types/tutorial';
import { useAtomValue } from 'jotai';
import type { ViewStyle } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

function getHomeExploreHighlightRef(step: number): TutorialRef | undefined {
  switch (step) {
    case 1:
      return TutorialRef.HeaderSearchBar;
    case 2:
      return TutorialRef.PublishButton;
    case 3:
      return TutorialRef.HeaderHelpButton;
    default:
      return undefined;
  }
}

interface UseTutorialHeaderButtonStyleOptions {
  /** White background while this ref is highlighted by the tutorial overlay. */
  tutorialRef: TutorialRef;
}

export function useTutorialHeaderButtonStyle({
  tutorialRef,
}: UseTutorialHeaderButtonStyleOptions): Pick<ViewStyle, 'backgroundColor' | 'borderWidth' | 'borderColor'> {
  const overlay = useAtomValue(presentTutorialOverlayAtom);
  const currentTutorial = useAtomValue(currentTutorialAtom);
  const currentStep = useAtomValue(currentTutorialStepAtom);

  return (() => {
    const overlayActive = overlay?.pointing === true && overlay.targetRef === tutorialRef;

    let isHighlighted = false;
    if (overlayActive && currentTutorial === Tutorial.HomeExplore) {
      const activeRef = getHomeExploreHighlightRef(currentStep);
      if (activeRef === tutorialRef) {
        isHighlighted = true;
      }
    }

    if (isHighlighted) {
      return {
        backgroundColor: theme.colors['surface.default'],
        borderWidth: 1,
        borderColor: theme.colors['surface.inverse.tertiary-neutral'],
      };
    }

    return {
      backgroundColor: 'transparent',
      borderWidth: 0,
      borderColor: 'transparent',
    };
  })();
}
